/**
 * Resolves a file path stored in the database (for example
 * "/uploads/blog/photo.png") into a URL the browser can actually load.
 *
 * Uploads are served by the API, not by the front-end origin, so in local
 * development a bare "/uploads/..." path resolves against the dev server and
 * 404s. Deriving the origin from REACT_APP_API_URL keeps this correct in both
 * environments: relative when the API is proxied, absolute when it is not.
 */
const API_BASE = process.env.REACT_APP_API_URL || '/api';

const API_ORIGIN = /^https?:\/\//i.test(API_BASE)
  ? API_BASE.replace(/\/api\/?$/, '')
  : '';

export const assetUrl = (path) => {
  if (!path) return null;
  if (/^(https?:)?\/\//i.test(path) || path.startsWith('data:')) return path;

  // Some rows were saved with a leading "/public" segment; normalise it away.
  const clean = (path.startsWith('/') ? path : `/${path}`).replace(/^\/public(?=\/)/, '');
  return `${API_ORIGIN}${clean}`;
};

/** Convenience helper for alumni photos, which may be stored as a bare filename. */
export const alumniPhotoUrl = (photo) => {
  if (!photo) return null;
  if (/^(https?:)?\/\//i.test(photo) || photo.startsWith('data:')) return photo;
  // Assets bundled in the front-end public folder are already correct paths.
  if (photo.startsWith('/images')) return photo;
  if (photo.startsWith('/uploads')) return assetUrl(photo);
  return assetUrl(`/uploads/alumni/${photo}`);
};
